import { useState } from 'react';
import { useLang } from '../../lib/language';

/**
 * Laundry TAKE IN: when will the order be ready? The answer is the promised
 * date the board sorts and flags overdue by (`CustomerDeliverDate`). Defaults
 * to tomorrow at 18:00 — the counter changes it per order.
 */
export function ReadyByDialog(props: {
  busy: boolean;
  onCancel: () => void;
  onConfirm: (readyByIso: string) => void;
  /** Pay at drop-off instead (opens the payment window). Absent = not offered. */
  onPayNow?: (readyByIso: string) => void;
}): JSX.Element {
  const { t } = useLang();
  const tomorrow = new Date(Date.now() + 86400_000);
  const pad = (n: number) => String(n).padStart(2, '0');
  const [date, setDate] = useState(
    `${tomorrow.getFullYear()}-${pad(tomorrow.getMonth() + 1)}-${pad(tomorrow.getDate())}`,
  );
  const [time, setTime] = useState('18:00');
  const valid = /^\d{4}-\d{2}-\d{2}$/.test(date) && /^\d{2}:\d{2}$/.test(time);

  // The local wall-clock the cashier picked, as an instant.
  const readyByIso = () => new Date(`${date}T${time}:00`).toISOString();
  const confirm = () => {
    if (!valid || props.busy) return;
    props.onConfirm(readyByIso());
  };
  const payNow = () => {
    if (!valid || props.busy || !props.onPayNow) return;
    props.onPayNow(readyByIso());
  };

  return (
    <div className="modal-overlay show" onClick={(e) => { if (e.target === e.currentTarget) props.onCancel(); }}>
      <div className="modal" style={{ maxWidth: 420 }}>
        <div className="modal-header">
          <div className="modal-title">{t({ en: 'Take in laundry', ar: 'استلام الغسيل' })}</div>
          <button className="btn-close" onClick={props.onCancel} aria-label={t({ en: 'Close', ar: 'إغلاق' })}>×</button>
        </div>
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ fontSize: 14, color: 'var(--text-muted)' }}>
            {t({
              en: 'When will the order be ready? The customer pays when collecting it — or now, at drop-off.',
              ar: 'متى سيكون الطلب جاهزاً؟ يدفع العميل عند الاستلام — أو الآن عند التسليم.',
            })}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <label className="laundry-field">
              <span>{t({ en: 'Ready on', ar: 'جاهز يوم' })}</span>
              <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
            </label>
            <label className="laundry-field">
              <span>{t({ en: 'At', ar: 'الساعة' })}</span>
              <input type="time" value={time} onChange={(e) => setTime(e.target.value)} />
            </label>
          </div>
        </div>
        <div className="modal-footer" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', padding: '12px 20px' }}>
          <button type="button" className="btn-secondary" onClick={props.onCancel}>
            {t({ en: 'Cancel', ar: 'إلغاء' })}
          </button>
          {props.onPayNow && (
            <button type="button" className="btn-secondary" disabled={!valid || props.busy} onClick={payNow}>
              {t({ en: 'Take in · pay now', ar: 'استلام · الدفع الآن' })}
            </button>
          )}
          <button type="button" className="btn-primary" disabled={!valid || props.busy} onClick={confirm}>
            {props.busy
              ? t({ en: 'Saving…', ar: 'جارٍ الحفظ…' })
              : t({ en: 'Take in · pay at pickup', ar: 'استلام · الدفع عند الاستلام' })}
          </button>
        </div>
      </div>
    </div>
  );
}
